var map = {
	"./-1.jpg": 545,
	"./0.jpg": 546,
	"./1.jpg": 547,
	"./10.jpg": 548,
	"./2.jpg": 549,
	"./3.jpg": 550,
	"./4.jpg": 551,
	"./5.jpg": 552,
	"./6.jpg": 553,
	"./7.jpg": 554,
	"./8.jpg": 555,
	"./9.jpg": 556,
	"./aris.jpg": 482,
	"./atamd.jpg": 483,
	"./belgeler.jpg": 484,
	"./bilge.jpg": 485,
	"./erdem.jpg": 486,
	"./hoyuk.jpg": 487,
	"./kitap.jpg": 557,
	"./tdkbelleten.jpg": 488,
	"./ttkbelleten.jpg": 489,
	"./turkdili.jpg": 490,
	"./turkdunyasi.jpg": 491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 475;